





































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {IssueConst} from '@/models/Issue'

@Component({
  components: {},
})
export default class FilterCurrent extends Vue {
  @Prop() filter: string[]
  @Prop() setFilter: (string)
  @Prop() clearFilter: (string)


  getTotalCount(options) {
    if (options.length ==  1){
      return options[0].count
    }else if (options.length > 0)
      return options.reduce((accumulator, option) => {
        // console.log('accumulator', accumulator)
        if (typeof accumulator == 'object') {
          accumulator = accumulator.count
        }
        return accumulator + parseInt(option.count)
      })
    return 0
  }

  getStatusColor(status) {
    return IssueConst.color(status)
  }
}

